// [VexFlow](https://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// MIT License

import { CustomFont } from './custom_glyphs';
import { CustomMetrics } from './custom_metrics';

export const Custom = {
  data: CustomFont,
  metrics: CustomMetrics,
};
